import React from "react";
import { Link } from "react-router-dom";
import AdminPageHeader from "../../components/AdminPageHeader";
import useUserRole from "../../hooks/useUserRole";
import useRolePermissions from "../../hooks/useRolePermissions";

function Card({ to, title, hint }) {
  return (
    <Link to={to} className="adminModuleCard" style={{ textDecoration: "none" }}>
      <div className="adminModuleTitle">{title}</div>
      <div className="adminModuleHint">{hint}</div>
    </Link>
  );
}

export default function ScheduleHome() {
  const { role, loading: roleLoading } = useUserRole();
  const { can, loading: permsLoading } = useRolePermissions(role);

  if (roleLoading || permsLoading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  const canSeeAnything = can("FullScheduleRead") || can("DailyOps");

  if (!canSeeAnything) {
    return (
      <div style={{ padding: 20 }}>
        <AdminPageHeader title="Schedule" />
        <p>You do not have access to this page.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <AdminPageHeader title="Schedule" />

      <div style={{ color: "#64748b", marginTop: -8, marginBottom: 18 }}>
        Full schedule, employee weekly view, daily operations, and time off requests
      </div>

      <div className="adminModuleGrid">
        {can("FullScheduleRead") && (
          <Card
            to="/admin/schedule/full"
            title="Full Schedule"
            hint="View and manage weekly staffing"
          />
        )}

        {can("FullScheduleRead") && (
          <Card
            to="/admin/schedule/employees"
            title="Employee Weekly View"
            hint="View employee schedules by week"
          />
        )}

        {can("FullScheduleRead") && (
        <Card
            to="/admin/schedule/shift-requests"
            title="Shift Requests"
            hint="Review and award open shift requests"
        />
        )}

        {can("FullScheduleRead") && (
          <Card
            to="/admin/schedule/time-off"
            title="Time Off Requests"
            hint="Review and approve employee time off requests"
          />
        )}
      </div>
    </div>
  );
}